class LinkedProductHover {
  constructor() {
    this.galleryElement = null;
    this.mainMediaElements = [];
    this.originalImages = [];
    this.preloadedImages = new Map();
    this.isHovering = false;
    
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    this.galleryElement = document.querySelector('[id^="ProductGallery-"]');
    
    if (!this.galleryElement) {
      console.warn('Product gallery not found');
      return;
    }

    this.mainMediaElements = Array.from(
      this.galleryElement.querySelectorAll('.product__media img')
    );

    this.storeOriginalImages();

    const linkedProductLinks = document.querySelectorAll('.custom_product_linked_link[data-hover-images]');
    
    if (linkedProductLinks.length === 0) {
      return;
    }

    this.preloadHoverImages(linkedProductLinks);

    linkedProductLinks.forEach(link => {
      link.addEventListener('mouseenter', (e) => this.handleMouseEnter(e));
      link.addEventListener('mouseleave', (e) => this.handleMouseLeave(e));
      
      link.addEventListener('click', (e) => {
        if (this.isHovering) {
          return true;
        }
      });
    });
  }

  storeOriginalImages() {
    this.originalImages = this.mainMediaElements.map(img => ({
      src: img.src,
      srcset: img.srcset || '',
      alt: img.alt || ''
    }));
  }

  preloadHoverImages(links) {
    links.forEach(link => {
      const hoverImagesAttr = link.getAttribute('data-hover-images');
      if (!hoverImagesAttr) return;

      const imageUrls = hoverImagesAttr.split('|||').filter(url => url.trim());
      
      this.preloadedImages.set(link, imageUrls);

      imageUrls.forEach(url => {
        const img = new Image();
        img.src = url;
      });
    });
  }

  handleMouseEnter(event) {
    event.preventDefault();
    this.isHovering = true;
    
    const link = event.currentTarget;
    const imageUrls = this.preloadedImages.get(link);
    
    if (!imageUrls || imageUrls.length === 0) {
      return;
    }

    this.switchGalleryImages(imageUrls);
  }

  handleMouseLeave(event) {
    this.isHovering = false;
    
    this.restoreOriginalImages();
  }

  switchGalleryImages(newImageUrls) {
    this.mainMediaElements.forEach((img, index) => {
      if (index < newImageUrls.length) {
        const parentMedia = img.closest('.product__media');
        if (parentMedia) {
          parentMedia.style.display = '';
        }
        
        img.src = newImageUrls[index];
        img.srcset = '';
        
        img.style.opacity = '0';
        
        img.onload = () => {
          img.style.transition = 'opacity 0.3s ease';
          img.style.opacity = '1';
        };
      } else {
        const parentMedia = img.closest('.product__media');
        if (parentMedia) {
          parentMedia.style.display = 'none';
        }
      }
    });

    this.updateThumbnails(newImageUrls);
  }

  updateThumbnails(newImageUrls) {
    const thumbnails = this.galleryElement.querySelectorAll('.product__thumbnails-list button img, .product__thumbnails-list img');
    
    thumbnails.forEach((thumb, index) => {
      if (index < newImageUrls.length) {
        const parentButton = thumb.closest('button');
        if (parentButton) {
          parentButton.style.display = '';
        }
        
        const thumbUrl = newImageUrls[index].replace(/width=\d+/, 'width=200');
        thumb.src = thumbUrl;
        thumb.style.opacity = '0';
        
        thumb.onload = () => {
          thumb.style.transition = 'opacity 0.2s ease';
          thumb.style.opacity = '1';
        };
      } else {
        const parentButton = thumb.closest('button');
        if (parentButton) {
          parentButton.style.display = 'none';
        }
      }
    });
  }

  restoreOriginalImages() {
    this.mainMediaElements.forEach((img, index) => {
      if (this.originalImages[index]) {
        const parentMedia = img.closest('.product__media');
        if (parentMedia) {
          parentMedia.style.display = '';
        }
        
        img.style.opacity = '0';
        img.src = this.originalImages[index].src;
        img.srcset = this.originalImages[index].srcset;
        img.alt = this.originalImages[index].alt;
        
        img.onload = () => {
          img.style.transition = 'opacity 0.3s ease';
          img.style.opacity = '1';
        };
      }
    });

    this.restoreThumbnails();
  }

  restoreThumbnails() {
    const thumbnails = this.galleryElement.querySelectorAll('.product__thumbnails-list button img, .product__thumbnails-list img');
    const originalThumbs = this.galleryElement.querySelectorAll('[data-original-thumb-src]');
    
    thumbnails.forEach((thumb, index) => {
      const parentButton = thumb.closest('button');
      if (parentButton) {
        parentButton.style.display = '';
      }
      
      const originalSrc = thumb.getAttribute('data-original-thumb-src');
      if (originalSrc) {
        thumb.src = originalSrc;
      }
    });
  }
}

new LinkedProductHover();
